import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicPipelining = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Pipelining: Two-Stage, Multi-Stage Pipelining, Basic Performance Issues"
      videos={[
        "https://www.youtube.com/embed/z7TOTY6uOPA?list=PLgwJf8NK-2e5CsijAZszH0wO-A298XKLx",
        "https://www.youtube.com/embed/yZIT5okhuXI?list=PLAXUYU7PbJhj8Cz_LZkZpEYSu5ITZakBo"
      ]}
      takeaways={[
        { text: "Understand how pipelining works and how to calculate time savings compared to normal execution." },
        { text: "Learn how to create timing diagrams for pipelining." },
        { text: "Study branch penalties and logic required to handle branches and interrupts in pipelining." }
      ]}
      questions={[
        "Illustrate a timing diagram for a typical 5-stage pipeline for 9 instructions. Analyze the effect of a conditional branch on the pipeline if instruction 3 branches to instruction 15 with the necessary branch penalty. Derive the logic needed for pipelining to account for branches and interrupts.",
        "Suppose an unpipelined processor with a 40ns cycle time is divided into 5 pipeline stages with latencies of 1,2,4,3, and 5ns. If the pipeline latch latency is 2ns, what is the cycle time of the resulting pipeline stage and pipelined processor?"
      ]}
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicPipelining;
